import React from 'react';
import { fileName } from '../../../../utils/Constants';
import { withRouter } from 'react-router-dom';
import TermsAndConditions from '../steps/TermsAndConditions';

const OlaClickTermsAndConditions = (props) => {
  const { match } = props;
  return <TermsAndConditions {...props} fileName={`${fileName.OlaClickTC}${match.params.country}.pdf`} />;
};

export default withRouter(OlaClickTermsAndConditions);
